module.exports = __webpack_public_path__ + "static/img/start.1c7cc86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Nails/start.jpg
// module id = Iz2a
// module chunks = 1